import dayjs from 'dayjs';
import { Coordinates } from '../coordinates.model';
import { UserEvent } from './user-event.model';
export class AppelClientEvent extends UserEvent {
  public static NAME = 'APPEL_CLIENT_EVENT';

  constructor(
    public idCreneau: string,
    public fin: dayjs.Dayjs,
    coordinates?: Coordinates
  ) {
    super(AppelClientEvent.NAME, undefined, coordinates);
  }

  public static hydrate(obj: AppelClientEvent): AppelClientEvent {
    return new AppelClientEvent(obj.idCreneau, dayjs(obj.fin), obj.coordinates);
  }
}
